import React from "react";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { Box, Button } from "Components";
import { ThemedDialog } from "Styles/ThemedPrimitives/_index";
import { WhatsNewViewModel } from "./WhatsNewViewModel";

interface IWhatsNewModalProps {
    viewModel: WhatsNewViewModel;
}

const Container = styled.div`
    padding: 10px 20px 30px;
    min-width: 360px;
    max-width: 520px;
    text-align: left;
`;

const VersionHeader = styled.div`
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #888;
    margin-bottom: 8px;
`;

const GroupLabel = styled.div`
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #555;
    margin: 16px 0 4px;

    &:first-of-type {
        margin-top: 0;
    }
`;

const ItemList = styled.ul`
    margin: 0 0 4px;
    padding-left: 20px;
`;

const Item = styled.li`
    font-size: 0.9rem;
    line-height: 1.6;
    color: #333;
    margin-bottom: 4px;
`;

export const WhatsNewModal = observer(({ viewModel }: IWhatsNewModalProps) => {
    if (!viewModel.currentEntry) return null;

    return (
        <ThemedDialog title="What's New" isOpen={viewModel.isOpen} onCloseCommand={viewModel.closeCommand} hideIcon>
            <Container>
                <VersionHeader>
                    {viewModel.currentEntry.buildLabel} &mdash; {viewModel.currentEntry.date}
                </VersionHeader>
                {viewModel.groupedItems.map((group) => (
                    <React.Fragment key={group.label}>
                        <GroupLabel>{group.label}</GroupLabel>
                        <ItemList>
                            {group.items.map((item) => (
                                <Item key={item.description}>{item.description}</Item>
                            ))}
                        </ItemList>
                    </React.Fragment>
                ))}
                <Box display="flex" justifyContent="center" style={{ marginTop: "20px" }}>
                    <Button command={viewModel.closeCommand} displayName="Got it" paletteColor="primary" style={{ borderRadius: "5px", minHeight: "40px" }} />
                </Box>
            </Container>
        </ThemedDialog>
    );
});
